import { EventCard } from '.'
import { EventRecord } from '../../../utils'
import EventListCard from './EventListCard'

interface Props {
  event: EventRecord
  listView?: boolean
  isLive?: boolean
  isUpcoming?: boolean
  showWorkspace: boolean
}

export default function EventCardRenderer({
  event,
  isLive,
  listView,
  isUpcoming,
  showWorkspace,
}: Props) {
  if (listView)
    return (
      <EventListCard
        {...event}
        isLive={isLive}
        isUpcoming={isUpcoming}
        showWorkspace={showWorkspace}
      />
    )
  return (
    <EventCard {...event} isLive={isLive} isUpcoming={isUpcoming} showWorkspace={showWorkspace} />
  )
}
